import React from 'react'
import ReactTable  from "react-table";
import {connect} from 'react-redux'
import axios from 'axios'
import {DRN} from '../report/daterange'
import {getToken, setLocalKeyValue, getLocalKeyValue, getDateRange, getUserSettings} from '../../storage'
import {API_BASE_URL, INVOICE_LIST_PAGE_SIZE} from '../../constants'
import { withRouter } from 'react-router-dom'
import Select from 'react-select';
import moment from 'moment'
import {Summation} from '../commons/tablefooters'
import {updateHistory} from '../commons/functions'
import SearchInput from '../search/search'
import _ from 'lodash'

class Invoices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRange : getDateRange(),
      data: [],
      pages: null,
      loading: true,
      client: props.location.state ? (props.location.state.client || null): null,
      department: props.location.state ? (props.location.state.department| null): null,
      item: props.location.state ? (props.location.state.item || null): null,
      invoice_search: props.location.state ? (props.location.state.invoice_search || null): null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateInvoice = this.goToCreateInvoice.bind(this)
    this.handleClientChange = this.handleClientChange.bind(this)
    this.handleItemChange = this.handleItemChange.bind(this)
    this.renderClientName = this.renderClientName.bind(this)
    this.getClients = this.getClients.bind(this)
    this.getItems = this.getItems.bind(this)
    document.title = "Invoices List"
  }


  downloadReport = (report_type) => {
    return   axios({
      url: report_type,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }



  downloadRateSales = (xls_url) =>{
    this.setState({downloading_invoices:true,})

    let apiurl = xls_url
    let dateRange = this.state.dateRange
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "?start_date="+start_date+"&end_date="+end_date
    }
    let item = this.state.item
    if(typeof item !== "undefined" && item !== null) {
      apiurl = apiurl + '&item_id='+item.id
    }
    let client  = this.state.client
    if(typeof client !== "undefined" && client !== null) {
      apiurl = apiurl + '&client_id='+client.id
    }

    this.downloadReport(apiurl).then((response)=> {
      this.setState({submitting_rate_sales:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_rate_sales:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  goToCreateInvoice(e) {
    e.preventDefault()
    this.props.history.push("/invoices/create/")
  }
  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/invoices/edit/'+row.original.serial)
      },
      style: {
        cursor:'pointer'
      }
    }
  }


  handleClientChange(value) {
    this.setState({client: value})
    this.fetchData(this.state.tableState, {}, value, this.state.item)
    updateHistory(this.props, {client:value})

  }
  handleItemChange(value) {
    this.setState({item: value})
    this.fetchData(this.state.tableState, {}, this.state.client, value)
    updateHistory(this.props, {item:value})
  }

  getDepartments = (input)=> {

    if(!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_departments/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.departments}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}

  getClients (input) {

    if(!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_clients/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.clients}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}

applyDateRange = (dateRange) => {
  this.fetchData(this.state.tableState, {}, this.state.client, this.state.item, dateRange)
}

getItems (input) {

  if(!input) {
    return Promise.resolve({ options: [] });
  }

  return   axios({
      url: '/list_items/?q='+input,
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
          return {options: response.data.items}
    }).catch((err)=> {
      return Promise.resolve({ options: [] });
    })
}

  renderClientName(option){
    return <span>{option.name} {option.city}</span>
  }

  renderTotalTax(row) {

    let item = this.state.item
    if(!item) {
      return  <div className="text-right">{parseFloat(parseFloat(row.original.totalTax) + parseFloat(row.original.totalCess)).toFixed(2)}</div>

    }
    else {
        let matchedItems = row.original.saleitem_set.filter((saleitem)=>saleitem.item === item.id)
        let gst=0
        matchedItems.forEach((i,id)=>{
          gst = gst + parseFloat(i.igst_amount) + parseFloat(i.cess_amount) + parseFloat(i.specific_cess_amount)
        })
        return <div className="text-right">{parseFloat(gst).toFixed(2)}</div>
    }

  }

  handleSearchInvoice = (q) => {
    this.fetchData(this.state.tableState, {}, this.state.client, this.state.item, this.state.dateRange, q)
    updateHistory(this.props, {invoice_search:q})
  }

  fetchData(state, instance, client=this.state.client, item=this.state.item, dateRange=this.state.dateRange, invoice_search=this.state.invoice_search, ) {


    this.setState({ loading: true });

    setLocalKeyValue(INVOICE_LIST_PAGE_SIZE, state.pageSize)
    let apiurl = "/list_invoices/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    const settings = getUserSettings()
    let enable_departments = false
    if(settings) {
      const settingsOptions = settings.options
      if(settingsOptions && settingsOptions.column_invoice_profits) {
          apiurl = apiurl + '&profits='+true
      }
      if(settingsOptions && settingsOptions.enable_departments) {
        enable_departments = true
      }
    }
    if(typeof client !== "undefined" && client !== null) {
      apiurl = apiurl + (enable_departments ? '&department_id=': '&client_id=') +client.id
    }
    if(typeof item !== "undefined" && item !== null) {
      apiurl = apiurl + '&item_id='+item.id
    }
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }

    if(invoice_search) {
      apiurl = apiurl + '&invoice_search='+invoice_search
    }

    this.setState({tableState:state,  dateRange:dateRange, invoice_search:invoice_search})
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.invoices,
        pages: res.data.pages,
        total_tax_value:res.data.total_tax_value.totalTax__sum,
        total_amount_value:res.data.total_amount_value.totalPrice__sum,
        total_invoice_value:res.data.total_invoice_value.total__sum,
        total_profit_value:res.data.total_profit_value ? res.data.total_profit_value.profit__sum : 0,
        total_quantity_value:res.data.total_quantity_value.saleitem__quantity__sum,
        loading: false
      });
    });
  }

  invoiceNameFormat(row) {
      let settings = getUserSettings()
      if(settings && settings.options && settings.options['append_series_name_as_suffix']) {
        return <div>{row.original.series_counter}{row.original.series_name}</div>
      }
      else {
          return <div>{row.original.series_name}{row.original.series_counter}</div>
      }

  }


  departmentNameFormat = (row)=> {

      if(row.original.department !== null) {
        const department = row.original.department
        return <div>{department.name}</div>
      }
      else {
        return null
      }
    }

  clientNameFormat(row) {

    if(row.original.client !== null) {
      const client = row.original.client
      return <div>{client.name} {client.city}</div>
    }
    else {
      return null
    }
  }

  amountFormat = (row) =>{
    let item = this.state.item
    if(!item) {
        return <div className="text-right">{row.original.totalPrice}</div>
    }
    else {
        let matchedItems = row.original.saleitem_set.filter((saleitem)=>saleitem.item === item.id)
        let p=0
        matchedItems.forEach((i,id)=>{
          p = p + parseFloat(i.price)
        })
        return <div className="text-right">{parseFloat(p).toFixed(2)}</div>
    }
  }

  quantityFormat = (row)=>{
    let item = this.state.item
    if(!item) {
        return <div className="text-right">{_.sum(_.map(row.original.saleitem_set, i=>{return parseFloat(i.quantity)}))}</div>
    }
    else {
        let matchedItems = row.original.saleitem_set.filter((sitem)=>sitem.item === item.id)
        let p=0
        matchedItems.forEach((i,id)=>{
          p = p + parseFloat(i.quantity)
        })
        return <div className="text-right">{p}</div>
    }
  }

  totalFormat = (row) =>{
    let item = this.state.item
    if(!item) {
        return <div className="text-right">{row.original.total}</div>
    }
    else {
        let matchedItems = row.original.saleitem_set.filter((saleitem)=>saleitem.item === item.id)
        let p=0
        matchedItems.forEach((i,id)=>{
          p = p + parseFloat(i.total)
        })
        return <div className="text-right">{parseFloat(p).toFixed(2)}</div>
    }
  }


  render() {
    let settings = getUserSettings()
    let options
    if(settings && settings.options) {
      options = settings.options
    }
    let xls_url = "/export_invoices_excel/"
    const { data, pages, loading } = this.state;
    let total_invoice_value, total_tax_value, total_amount_value, total_profit_value, total_quantity_value
    if(this.state.total_invoice_value) {
      total_invoice_value = parseFloat(this.state.total_invoice_value).toFixed(2)
    }
    if(this.state.total_tax_value) {
      total_tax_value = parseFloat(this.state.total_tax_value).toFixed(2)
    }
    if(this.state.total_amount_value) {
      total_amount_value = parseFloat(this.state.total_amount_value).toFixed(2)
    }

    if(this.state.total_profit_value) {
      total_profit_value = parseFloat(this.state.total_profit_value).toFixed(2)
    }
    if(this.state.total_quantity_value) {
      total_quantity_value = parseFloat(this.state.total_quantity_value).toFixed(2)
    }

    let enable_departments = false

    let columns = []

    columns.push(
      {Header:'Date', accessor: 'date', sortable:true,
         Cell:(row)=>(<div className="text-center">{moment(row.original.date).format('DD-MM-YYYY')}</div>)},
      {Header:'Invoice', accessor:'serial', Cell:(row)=>{return this.invoiceNameFormat(row)}},
      )

    if(options) {

      if(options.enable_departments) {
        enable_departments = true
      }

      if(enable_departments) {
          columns.push({Header:'Cost center', accessor: 'department__name',sortable:true, Cell:(row)=>{return this.departmentNameFormat(row)} })
      }
      else {
        columns.push({Header:'Client', accessor: 'client__name',sortable:true, Cell:(row)=>{return this.clientNameFormat(row)} })
      }

      if(options.invoice_table_col_quantity) {
        columns.push({Header:'Quantity',  accessor:'quantity',sortable:true,
          Footer:()=>{
            if(this.state.item) {
              return <Summation innerArray="saleitem_set" data={data}
                innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}
                fields={['quantity']}  />
            }
            else {
              return <Summation innerArray="saleitem_set" data={data} field="quantity" full_sum={total_quantity_value}  />
            }
          },
           Cell:(row)=>{return this.quantityFormat(row)} })
      }
    }

    columns.push({Header:'Amount',
      Footer: ()=>{
        if(this.state.item) {
            return (<Summation data={data} fields={['price']} innerArray="saleitem_set"
            innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}  />)
        }
        else {
            return <Summation data={data} field="totalPrice" full_sum={total_amount_value} />
        }

      },
      accessor:'totalPrice',sortable:true, Cell:(row)=>{return this.amountFormat(row)} },
    {Header:'Tax',
      Footer: ()=>{
        if(this.state.item) {
          return <Summation data={data} innerArray="saleitem_set"
            innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}
             fields={['igst_amount', 'cess_amount', 'specific_cess_amount']}  />
        }
        else {
            return <Summation data={data} field="totalTax" fields={['totalTax', 'totalCess']} full_sum={total_tax_value} />
        }

      },
       accessor:'totalTax', sortable:true, Cell:(row)=>{return this.renderTotalTax(row)}
     },
    {Header:'Total',
      Footer: ()=>{
        if(this.state.item) {
          return <Summation data={data} fields={['total']} innerArray ="saleitem_set"
            innerArrayFilterKey="item" innerArrayFilterVal={this.state.item.id||undefined}
             />
        }
        else {
          return <Summation data={data} field="total" full_sum={total_invoice_value} />
        }
      },
      accessor:'total', sortable:true, Cell:(row)=>{return this.totalFormat(row)} },)




      if(options) {

        if(options.column_invoice_created) {
          columns.splice(1,0, {Header:'Created', accessor: 'created', sortable:true,
             Cell:(row)=>(<div className="text-center">{moment(row.original.created).format('DD-MM-YYYY')}</div>)})
        }
        if(options.column_invoice_profits) {
          columns.push({
            Header:'Profit',
            Footer: (<Summation data={data} field="profit" full_sum={total_profit_value} />),
            accessor: 'profit', Cell: (row)=>(<div className="text-right">{parseFloat(row.original.profit).toFixed(2)}</div>)
          })
        }
        if(options.created_and_modified_user_info) {
          columns.push({Header:'Created By', Cell:(row)=>(<div className="text-center">{ row.original.created_by ? row.original.created_by.username: ""}</div>)})
          columns.push({Header:'Modified By', Cell:(row)=>(<div className="text-center">{ row.original.modified_by ? row.original.modified_by.username: ""}</div>)})
        }

        if(options.invoice_xls_download_format === "format_b") {
          xls_url = "/export_invoices_excel_format_b/"
        }
      }

    const defaultSort=[{id: "date", desc: true}]

    let pageSize = getLocalKeyValue(INVOICE_LIST_PAGE_SIZE)

    if(typeof pageSize === "undefined"){
      pageSize = 20
    }
    else {
      pageSize = parseInt(pageSize, 10)
    }


    let select_client
    if(enable_departments) {
      select_client =  <div className="col-sm-4 mtop">
            <Select.Async multi={false} onChange={this.handleClientChange} valueRenderer={this.renderDepartmentName}
            optionRenderer={this.renderDepartmentName} value={this.state.client} valueKey="id" labelKey="name"
            loadOptions={this.getDepartments} backspaceRemoves={true} placeholder="Select CostCenter"/>
      </div>
    }
    else {
      select_client =  <div className="col-sm-4 mtop">
            <Select.Async multi={false} onChange={this.handleClientChange} valueRenderer={this.renderClientName}
            optionRenderer={this.renderClientName} value={this.state.client} valueKey="id" labelKey="name"
            loadOptions={this.getClients} backspaceRemoves={true} placeholder="Select Client"/>

      </div>
    }


    return <div><section className="medium">

    <div className="row">
    <div className="col-sm-2">
    <button onClick={this.goToCreateInvoice} className="btn btn-primary">Create New Invoice</button>
    </div>

    <div className="col-sm-7">
      <div className="row">
        <div className="col-sm-4 mtop">
          <SearchInput value={this.state.invoice_search} handleSearchInput={this.handleSearchInvoice} placeholder={"Search Invoice"} />
        </div>
        {select_client}
        <div className="col-sm-4 mtop">
            <Select.Async multi={false} onChange={this.handleItemChange}
            value={this.state.item} valueKey="id" labelKey="name"
            loadOptions={this.getItems} backspaceRemoves={true} placeholder="Select Item"/>
        </div>
      </div>
    </div>

    <div className="col-sm-3 mtop">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
    </div>

    </div>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadRateSales(xls_url)}}>Download xls</button></div>
        <div className="table-responsive">
          <ReactTable defaultSorted={defaultSort}
            getTrProps={this.handleTrclick}
            noDataText="No Invoices Found."
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={pageSize} />
        </div>

      </div>
    </div>

    </div>
  }
}


const mapStateToProps = (state) => {
  return {
    invoice: state.invoiceReducer
  }
}

export default connect(mapStateToProps)(withRouter(Invoices));



// WEBPACK FOOTER //
// ./src/components/invoice/invoicelist2.js